import BucketEntity from "../../../domain/entities/BucketEntity";

const fromJson = (json: any): BucketEntity => {
    return {
        bucket_id: json.bucket_id,
        name: json.name,
        parent_bucket: json.parent_bucket ?? null,
        user_count: json.user_count ?? json.users_count ?? 0,
        hasWarning: json.has_warning === 1 || json.has_warning === true,
    };
};

const toJson = (bucket: BucketEntity): any => {
    return {
        bucket_id: bucket.bucket_id,
        name: bucket.name,
        parent_bucket: bucket.parent_bucket,
        user_count: bucket.user_count,
    };
};

const bucketDto = {
    fromJson,
    toJson
}

export default bucketDto
